import React from 'react';
import { CTAButton } from './CTAButton';
export function FinalCTASection() {
  return <section className="bg-gradient-to-br from-gray-900 via-black to-gray-900 py-24 px-4 text-center border-t-8 border-[#D4AF37]" data-id="element-113">
      <div className="max-w-4xl mx-auto" data-id="element-114">
        <h2 className="text-4xl md:text-6xl font-black text-white uppercase tracking-tight mb-8 leading-tight" data-id="element-115">
          No dejes pasar esta oportunidad de aprender una{' '}
          <span className="text-[#D4AF37]" data-id="element-116">habilidad rentable</span>
        </h2>

        <p className="text-xl md:text-2xl text-gray-300 font-medium mb-12 max-w-3xl mx-auto leading-relaxed" data-id="element-117">
          Los autos siempre van a necesitar cuidado. El mercado del detailing
          está creciendo en Argentina. Empieza hoy, aprende el método correcto y
          transforma tu pasión por los autos en ingresos reales.
        </p>

        <CTAButton text="SÍ, QUIERO EMPEZAR HOY MISMO" className="w-full md:w-auto md:min-w-[400px] text-xl py-6" data-id="element-118" />

        <p className="mt-8 text-gray-500 font-medium" data-id="element-119">
          Oferta especial de $29.990 ARS + 3 Bonos Gratis disponible por tiempo
          limitado.
        </p>
      </div>
    </section>;
}